import { Component, OnInit, Input, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'kt-confirm-entity-dialog',
  templateUrl: './confirm-entity-dialog.component.html',
  styleUrls: ['./confirm-entity-dialog.component.scss']
})
export class ConfirmEntityDialogComponent implements OnInit {

  alertShowing: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<ConfirmEntityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  closeDialog(isConfirmed) {
    this.dialogRef.close(isConfirmed);
  }

}

